export default __webpack_public_path__ + "static/media/first_last_zip5.a73c3742.csv";